module.exports = __webpack_public_path__ + "static/media/soils_reports_2.76a1a5f9.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_2.png
// module id = 1289
// module chunks = 0